<template>
  <ReleasesListAdminTable
    showCreatedAt
    showUpdatedAt
    :releases="releases"
    @delete="deleteRelease"
  ></ReleasesListAdminTable>
</template>

<script>
import { ReleasesMixin } from "@/mixins";
import ReleasesListAdminTable from "@/components/ReleasesListAdminTable";
export default {
  name: "ReposDraft",
  mixins: [ReleasesMixin],
  components: {
    ReleasesListAdminTable
  },
  created() {
    this.listReleases(true);
  }
};
</script>
